import React from 'react';
import PropTypes from 'prop-types';

function LeftLegBorder({ color }) {
  return (
    <path
      d="M86.7746 440.191C81.188 435.934 76.3441 424.349 72.4027 411.064C70.7852 439.686 73.5976 459.714 83.0375 471.93C102.497 497.112 112.572 503.46 133.407 507.073C147.656 509.541 187.21 513.135 203.235 471.926C204.628 468.348 205.958 464.664 207.236 460.919C198.256 462.886 187.556 464.381 175.303 464.612C134.854 465.375 102.801 452.401 86.7746 440.191Z"
      fill={color}
    />
  );
}

LeftLegBorder.propTypes = {
  color: PropTypes.string,
};

LeftLegBorder.defaultProps = {
  color: '#383D43',
};

export default LeftLegBorder;
